<template>
<div >
    <div v-for="list in statusCount" :key="list.transactionStatus"> Count of {{ list.transactionStatus }} transaction : {{ list.count }}</div>
    <div> Sum of transaction : {{ this.allTransactionCount }}</div>
    <br/>
</div>
</template>

<script>
import api from '../services/api'

export default {
    data() {
        return {
        statusCount: '',
        allTransactionCount: 0,
        }
    },
    async created() {
        this.init()
    },
    methods: {
        async init() {
            const transactionStatusCount = api('request-sample/status')
            const statusCount = await transactionStatusCount.get()
            this.statusCount = statusCount
            await this.countAllTransaction()
        },
        countAllTransaction() {
            var Total = this.statusCount.map((x) => {
                this.allTransactionCount += parseInt(x.count)
            })
        }
    }
}
</script>